import { colors, fonts } from '@grupoboticario/flora-tokens/casaMagalhaesCereja/web/ds'

export const casaMagalhaesCereja = {
  colors,
  fonts,
}
